/**
 * Achievements of a project.
 *
 * The backend sends a flat list of achievements; both the project detail page and the project list
 * item render the same five badges from it, and the store normalises the aggregated summary.
 */
/**
 * Whether the given achievement type is unlocked for a project.
 *
 * @param achievements Achievements of the project; missing or malformed input counts as none.
 * @param type         Achievement type, e.g. `'isReferral'`.
 * @returns `true` when an entry of that type is marked as achieved.
 */
export const isAchievementUnlocked = (achievements, type) => Array.isArray(achievements) &&
    achievements.some((achievement) => achievement.type === type && achievement.isAchieved);
/**
 * Normalises the `/achievements/summary` payload. The endpoint answers either as a list of items
 * (each carrying its own `type`) or already keyed by type; both become the keyed form.
 *
 * @param summary Payload of the endpoint.
 * @returns Achievements keyed by type; `{}` for missing or unusable input.
 */
export const normalizeAchievementsSummary = (summary) => {
    if (Array.isArray(summary)) {
        return summary.reduce((acc, currentItem) => {
            const { type, ...rest } = currentItem;
            if (type) {
                acc[type] = rest;
            }
            return acc;
        }, {});
    }
    if (summary && typeof summary === 'object') {
        return summary;
    }
    return {};
};
//# sourceMappingURL=achievements.js.map